import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import FlowRateUnitForm from '../Forms/FlowRateUnitForm';

const AddEditFlowRateUnitModal = ({
	dataFlowRateUnit,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Unidad de Medida
			</ModalHeader>

			<FlowRateUnitForm
				dataFlowRateUnit={dataFlowRateUnit}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditFlowRateUnitModal;
